export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/contacts/state.js